import mathUtil from './math';

var getValidNumericValue = function getValidNumericValue(newValue, prevValue, min, max) {
  var shouldRoundByStep = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var step = arguments.length > 5 ? arguments[5] : undefined;
  var fractionDigits = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 2;
  var returnValue = isNaN(newValue) ? prevValue : newValue;
  var valueRoundedByStep = shouldRoundByStep ? mathUtil.roundByStep(returnValue, step || 1) : returnValue;
  var valueDecimalPointFixed = mathUtil.fixDecimalPoint(valueRoundedByStep, fractionDigits);
  var valueInRange = mathUtil.getValueInRange(valueDecimalPointFixed, min, max);
  return String(valueInRange);
};

export default {
  getValidNumericValue: getValidNumericValue
};